import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Err4XXPopupComponent } from './err4xx/errors4xx-popup.component';
import { ButtonModule } from '@shared';
import { MatDialogModule } from '@angular/material/dialog';
import { LinkModule } from '../../link/link.module';
import { Err5XXPopupComponent } from './err5xx/errors5xx-popup.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [Err4XXPopupComponent, Err5XXPopupComponent],
  imports: [CommonModule, ButtonModule, MatDialogModule, LinkModule, TranslateModule],
})
export class ErrorsPopupModule {}
